import { IMAGE_SRC } from "../../common/constants";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setInfoSongPlayer } from "../../store/features/audioSlice";
import { RootState } from "../../store/store";

function Footer() {
  const dispatch = useDispatch();
  const playlist = useSelector((state: RootState) => state.audio.playlist);
  const currentIndexSong = useSelector(
    (state: RootState) => state.audio.currentIndexSong
  );
  const inforSongPlayer = useSelector(
    (state: RootState) => state.audio.inforSongPlayer
  );
  React.useEffect(() => {
    dispatch(
      setInfoSongPlayer({
        name: playlist?.songs[currentIndexSong]?.name,
        thumbnail: playlist?.songs[currentIndexSong]?.thumbnail,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndexSong, playlist?.songs]);
  return (
    <div className="absolute h-[100px] bottom-0 left-0 right-0 z-20 flex items-center w-full p-8">
      <div className="flex w-[190px] flex-shrink-0  gap-x-3 items-center">
        <span className="song-name inline-block mt-[6px] select-none text-white font-normal text-base">
          {inforSongPlayer?.name}
        </span>
        {!inforSongPlayer?.thumbnail && (
          <div className="w-5 relative">
            <img src={IMAGE_SRC.playing} alt="" />
          </div>
        )}
        {inforSongPlayer?.thumbnail && (
          <div className="w-10 rounded-md relative">
            <img
              className="rounded-md"
              src={inforSongPlayer?.thumbnail}
              alt=""
            />
          </div>
        )}
      </div>
    </div>
  );
}
export default React.memo(Footer);
